import React from "react";
import { Jumbotron, Container } from "reactstrap";
import Typical from "react-typical";
import NavCards from "../../components/userSide/navCards";
import "./style.css";

class Home extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      openNotFound: false,
      route: "signin",
      isSignedIn: false,
    };
  }

  toggle = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  };

  render() {
    return (
      <div className="homePage animate__animated animate__fadeIn">
        <Jumbotron
          className="homeJumbotron animate__animated animate__fadeInUpBig"
          fluid
        >
          <Container fluid>
            <h1 className="display-3 tc i orange">-LEARN TO EARN-</h1>
            <Typical
              steps={["Welcome!", 4000, "Champion's at WORK!", 4000]}
              loop={Infinity}
              wrapper="p"
              className="lead tc i"
            />
          </Container>
        </Jumbotron>
        <NavCards />
      </div>
    );
  }
}

export default Home;
